export default __webpack_public_path__ + "static/media/5.94327eef.jpg";